import type { ReactNode } from 'react';

export const symbol_punch_clock: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M180-80q-23 0-41.5-18.5T120-140v-520q0-23 18.5-41.5T180-720h70v-140q0-24.75 17.63-42.38Q285.25-920 310-920h340q24.75 0 42.38 17.62Q710-884.75 710-860v140h70q23 0 41.5 18.5T840-660v520q0 23-18.5 41.5T780-80H180Zm130-640h340v-140H310v140ZM180-140h600v-520H180v520Zm300.05-65Q561-205 618-262.05q57-57.06 57-138Q675-481 617.95-538q-57.06-57-138-57Q399-595 342-537.95q-57 57.06-57 138Q285-319 342.05-262q57.06 57 138 57Zm0-50Q420-255 377.5-297.45T335-399.95q0-60.05 42.45-102.55t102.5-42.5q60.05 0 102.55 42.45t42.5 102.5q0 60.05-42.45 102.55T480.05-255ZM500-408v-72q0-8-6-14t-14-6q-8 0-14 6t-6 14v76q0 5.57 2 10.78 2 5.22 7 10.22l43 43q6 6 14 6t14-6q6-6 6-14t-6-14l-40-40Zm-20 8Z"
		/>
	</svg>
);
